<template>
    <div
        class="active-right-subtitle relative"
        :style="{height: height + 'px'}"
    >

        <div
            class="active-right-subtitle-line hot-left absolute"
            :style="{
            width: width + 'px',
            backgroundColor: backgroundColor,
            top: top + 'px'
        }"
        ></div>

        <slot>

            <div class="active-right-subtitle-text">HOT</div>

        </slot>

        <div
            class="active-right-subtitle-line hot-right absolute"
            :style="{width: width + 'px',backgroundColor: backgroundColor,top: top+'px'}"
        ></div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "lineTitle",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
